import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/EiInformation';
import eiApplicationService, { getSections } from '../../../../../services/Internal/Application/EI/eiApplication.service';
import applicationService from '../../../../../services/Internal/Application/application.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import ReviewPdf from '../../../../Shared/Card/ReviewPdf';
import { Form, List } from 'rsuite';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import BaseSummarySheet from '../../../SummarySheets/BaseSummarySheet';
import SummarySheetPdf from '../../../SummarySheets/SummarySheetPdf';

function ReviewPage() {
    const [hasLoaded, setHasLoaded] = useState(false)
    const push = useNavigate();
    const [saveSummarySheet, setSaveSummarySheet] = useState(0)
    const [downloadSummarySheet, setDownloadSummarySheet] = useState(0)
    const [downloadCombo, setDownloadCombo] = useState(0)
    const appId = useSelector(x => x.currentApplicationId);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 9;
    const [allSections, setAllSections] = useState([]);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineer Intern Application",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Review"
        }
    );
    useEffect(() => {
        getSections().then(setAllSections);
        eiApplicationService.eiGetSection(appId, sectionId).then((response) => {
            setIsComplete(response.data.staffReviewComplete);
            applicationService.getIndividualApplication(appId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            })
        })
    }, [])

    const formSubmit = () => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            setSaveSummarySheet(saveSummarySheet + 1);
            eiApplicationService.eiMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
                if (data.data)
                    push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
            })
        }
    }

    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Row>
                    <Col>
                        <Information content={GetAppInformationContent("review")} className="mb-3" />
                    </Col>
                </Row>
                <br />
                <ReviewPdf id={appId} parentTypeId={1} />
                <SummarySheetPdf
                    downloadSummarySheet={downloadSummarySheet}
                    setDownloadSummarySheet={setDownloadSummarySheet}
                    downloadCombo={downloadCombo}
                    setDownloadCombo={setDownloadCombo}
                    id={appId}
                    parentTypeId={1}
                />
                <br />
                <br />
                {hasLoaded ?
                    <>
                        <BaseSummarySheet
                            isUserEditable={isUserEditable}
                            entityId={entityInfo.entityId}
                            parentId={appId}
                            parentTypeId={1}
                            saveSummarySheet={saveSummarySheet}
                            appTypeId={appTypeId}
                            downloadSummarySheet={downloadSummarySheet}
                            setDownloadSummarySheet={setDownloadSummarySheet}
                            downloadCombo={downloadCombo}
                            setDownloadCombo={setDownloadCombo}
                        />
                        <br />
                        <br />
                        <Form onSubmit={formSubmit}>
                            <FormActionButtons
                                isUserEditable={isUserEditable}
                                isComplete={isComplete}
                                isCompleteCallback={setIsComplete}
                                showSectionComplete={true}
                                backToSectionLink="/internal/eiapp/sections"
                            />
                        </Form>
                    </>
                    : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ReviewPage